import { render, staticRenderFns } from "./videoPlay.vue?vue&type=template&id=af651d46&scoped=true"
import script from "./videoPlay.vue?vue&type=script&lang=js"
export * from "./videoPlay.vue?vue&type=script&lang=js"
import style0 from "./videoPlay.vue?vue&type=style&index=0&id=af651d46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af651d46",
  null
  
)

export default component.exports